/**
 * Resolve institution_logo from member API to a usable image src.
 * Raw base64 is prefixed with data:image/png;base64,
 */
export const resolveInstitutionLogoSrc = (
  logo?: string | null,
): string | undefined => {
  if (!logo?.trim()) {
    return undefined;
  }

  const trimmed = logo.trim();
  if (/^data:/i.test(trimmed) || /^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `data:image/png;base64,${trimmed}`;
};
